module.exports = __webpack_public_path__ + "media/images/users/purchases/rank_desc_jp-2b47a05b1b5dbe3c3f68c14951507c74.png";